module.exports = __webpack_public_path__ + "img/galery-smart-scan-3.87041a94.png";